export default __webpack_public_path__ + "media/393a7828d0194f9b7e20eb480d52d321fef91db03fc257307084e898ed06e7ea.svg";